import ApiService from "@/api/ApiService";
import Vue from "vue";


export const IframeService = {
  baseURL: `${process.env.VUE_APP_IFRAME_URL}`,
  //baseURL: 'https://621e4716849220b1fc95200d.mockapi.io',
  /*config: {
    headers: {
      'Authorization': `Bearer ${process.env.VUE_APP_IFRAME_TOKEN}`
    }
  },*/

  getPageById(id) {
    return ApiService.get(`${this.baseURL}v1/pages`, id)
    //return ApiService.get(`${this.baseURL}/pages/info`, id, this.config)
  },

  deletePage(pageResourceIdentifier, ids) {
    return ApiService.delete(`${this.baseURL}v1/${pageResourceIdentifier}/?ids=${ids}`)
  },

  cloneBlock(pageResourceIdentifier, mode, ids) {
    let params = {
      mode: mode,
      ids: ids
    }
    return ApiService.post(`${this.baseURL}v1/${pageResourceIdentifier}/clone`, params)
  },

  lockBlock(pageResourceIdentifier, isLocking, ids) {
    let params= {
      lock: isLocking,
      ids: ids
    }

    return ApiService.patch(`${this.baseURL}v1/${pageResourceIdentifier}/lock?ids=${params.ids}&lock=${params.lock}`, params)
  },

  // --- Contact Pages ---
  createContactPage(params) {
    return ApiService.post(`${this.baseURL}v1/contact-pages`, params)
  },

  updateContactPage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/contact-pages/${id}`, params)
  },

  // --- End Contact Pages ---

  // --- Info Pages ---
  createInfoPage(params) {
    return ApiService.post(`${this.baseURL}v1/info-pages`, params)
  },

  updateInfoPage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/info-pages/${id}`, params)
  },
  // --- End Info Pages ---

  // --- Thanks Pages ---
  createThanksPage(params) {
    return ApiService.post(`${this.baseURL}v1/thanks-pages`, params)
  },

  updateThanksPage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/thanks-pages/${id}`, params)
  },
  // --- End Thanks Pages ---


  // --- Tonal Pages ---
  createTonalPage(params) {
    return ApiService.post(`${this.baseURL}v1/tonal-pages`, params, this.config)
  },

  updateTonalPage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/tonal-pages/${id}`, params, this.config)
  },
  // --- End Tonal Pages ---

  // --- Noise Pages ---
  createNoisePage(params) {
    return ApiService.post(`${this.baseURL}v1/noise-pages`, params, this.config)
  },

  updateNoisePage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/noise-pages/${id}`, params, this.config)
  },
  // --- End Noise Pages ---

  // --- Biosigns Pages ---
  createBiosignsPage(params) {
    return ApiService.post(`${this.baseURL}v1/biosignals-pages`, params, this.config)
  },

  updateBiosignsPage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/biosignals-pages/${id}`, params, this.config)
  },


  // --- End Biosigns Pages ---



  // --- Projects ---
  getFlowByHash(hash) {
    return ApiService.get(`${this.baseURL}v1/test-flow`, hash)
  },

  createFlow(params) {
    return ApiService.post(`${this.baseURL}v1/test-flow`, params)
  },

  updateFlow(flowId, params) {
    return ApiService.patch(`${this.baseURL}v1/test-flow/${flowId}`, params)
  },

  deleteFlow(flowHashes) {
    return ApiService.delete(`${this.baseURL}v1/test-flow/?hashes=${flowHashes}`)
  },

  cloneFlow(mode, ids) {
    let params = {
      mode: mode,
      ids: ids
    }
    return ApiService.post(`${this.baseURL}v1/test-flow/clone`, params)
  },

  lockFlow(isLocking, hashes) {
    let params= {
      lock: isLocking,
      hashes: hashes
    }
    return ApiService.patch(`${this.baseURL}v1/test-flow/lock?hashes=${params.hashes}&lock=${params.lock}`, params)

    //return ApiService.patch(`${this.baseURL}v1/${pageResourceIdentifier}/lock?ids=${params.ids}&lock=${params.lock}`, params)

  },

  updateAdjustVolumeAudio(flowId, file) {
    return ApiService.patch(`${this.baseURL}v1/test-flow/${flowId}/adjust_volume_audio`, file, {
      headers: {
        ...(file !== null ? {'Content-Type': 'multipart/form-data'} : {})
      }
    })

  },

  getNoiseItems() {
    return Vue.axios.get(`${this.baseURL}v1/noise-items/minified`, this.config)
  },

  getPages() {
    //return ApiService.query(`${this.baseURL}/pages`)
    return Vue.axios.get(`${this.baseURL}v1/pages`)
  },
  // --- End Projects ---

  // --- Media ---
  getMediaById(id) {
    return ApiService.get(`${this.baseURL}v1/noise-items`, id)
  },

  createMedia(params, isfiles = false) {
    return ApiService.post(`${this.baseURL}v1/noise-items`, params, {
      headers: {
        ...( isfiles ? {'Content-Type': 'multipart/form-data' } : {})
      }
    })
    // return ApiService.post(`${this.baseURL}v1/noise-items`, params, this.config)
  },

  updateMedia(mediaId, params, isfiles = false) {
    return ApiService.patch(`${this.baseURL}v1/noise-items/${mediaId}`, params, {
      headers: {
        ...( isfiles ? {'Content-Type': 'multipart/form-data' } : {})
      }
    })
  },

  deleteMedia(mediaId) {
    return ApiService.delete(`${this.baseURL}v1/noise-items/?ids=${mediaId}`)
  },

  lockMedia(isLocking, ids) {
    let params= {
      lock: isLocking,
      ids: ids
    }

    return ApiService.patch(`${this.baseURL}v1/noise-items/lock?ids=${params.ids}&lock=${params.lock}`, params)
  },

  getMedias() {
    return Vue.axios.get(`${this.baseURL}v1/noise-items`)
  },
  // --- End Media ---

  // --- Questionnaire Page ---
  createQuestionnairePage(params) {
    return ApiService.post(`${this.baseURL}v1/questionnaire-pages`, params)
  },

  updateQuestionnairePage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/questionnaire-pages/${id}`, params)
  },

  deleteQuestionnairePage(id) {
    return ApiService.delete(`${this.baseURL}v1/questionnaire-pages/?ids=${id}`)
  },
  //--- End Questionnaire Page ---

  // --- UserInfo Page ---
  createUserInfoePage(params) {
    return ApiService.post(`${this.baseURL}v1/user-info-pages`, params)
  },

  updateUserInfoPage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/user-info-pages/${id}`, params)
  },

  //--- End UserInfo Page ---

  createLogo(params, isFiles = false) {
    return ApiService.post(`${this.baseURL}v1/test-flow/logo`, params, {
      headers: {
        ...( isFiles ? {'Content-Type': 'multipart/form-data'}: {})
      }
    })
  },
  updateLogo(id, params, isFiles = false) {
    return ApiService.patch(`${this.baseURL}v1/test-flow/logo/${id}`, params, {
      headers: {
        ...( isFiles ? {'Content-Type': 'multipart/form-data'}: {})
      }
    })
  },

  getLogoById(id) {
    return ApiService.get(`${this.baseURL}v1/test-flow/logo/full/${id}`)
  },

  getAllLogos() {
    return ApiService.get(`${this.baseURL}v1/test-flow/logo/all/?limit=50`)
  },

  getFlowStatistics(hash, entity, start, end) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/sessions/flow-stats?hash=${hash}&entity=${entity}&start=${start === null ? '' : start}&end=${end === null ? '' : end}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  getSessionStatistics(sessionId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/sessions/${sessionId}/flow-stats`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  downloadBiosignsAccessCodesExcel(params) {
    return ApiService.blob(`${this.baseURL}v1/biosignals/accesscodes/export`, params)
  },

  getAllFlowsUnpaginated() {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/test-flow/all/unpaginated`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  createBiosignalsAccessCodes(body) {
    return ApiService.post(`${this.baseURL}v1/biosignals/accesscodes`, body)
  },

  postScanPack(body) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}v1/biosignals-scan-packs`, body)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })

  },

  deactivatePack(id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${this.baseURL}v1/biosignals-scan-packs/${id}/deactivate`, {})
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  getBiosignsStats(entities) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}v1/biosignals/accesscodes/stats?entities=${entities}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },

  // --- Anamnese Page ---
  createAnamnesePage(params) {
    return ApiService.post(`${this.baseURL}v1/anamnese-pages`, params)
  },

  updateAnamnesePage(id, params) {
    return ApiService.patch(`${this.baseURL}v1/anamnese-pages/${id}`, params)
  },

  deleteAnamnesePage(id) {
    return ApiService.delete(`${this.baseURL}v1/anamnese-pages/?ids=${id}`)
  },
  //--- End Anamnese Page --

}
